import React, {useContext} from 'react';
import Context from '../OriginStoryProvider';
import DeepDiveParagraph from '../Shared/DeepDiveParagraph';

const DeepDive2 = () => {
	const { data: {content} } = useContext(Context);

	const deepDiveImages = {
		'deep_dive_2_1': {
			images: [
				{
					'img_src': `${mainScript.assetPath}images/png/chapter-3/unkn-blaisdell-Fam-florence-lena-carrier-blaisdell.png`,
					'img_alt': ''
				},
				{
					'img_src': `${mainScript.assetPath}images/png/chapter-3/1922-blaisdell-Fam-barbara-blaisdell.png`,
					'img_alt': ''
				},
				{
					'img_src': `${mainScript.assetPath}images/png/chapter-3/1915-blaisdell-Fam-paul-blaisdell.png`,
					'img_alt': ''
				},
				{
					'img_src': `${mainScript.assetPath}images/png/chapter-3/918-blaisdell-Fam-allen-blaisdell.png`,
					'img_alt': ''
				},
				{
					'img_src': `${mainScript.assetPath}images/png/chapter-3/1911-blaisdell-Fam-james-brooks.png`,
					'img_alt': ''
				},
				{
					'img_src': `${mainScript.assetPath}images/png/chapter-3/blaisdell-Fam-Midget-blaisdell.png`,
					'img_alt': ''
				},
			]
		},
	}

	return (
		<div className='chapter-3__deep-dive--2 main-grid'>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<div className='chapter-3__deep-dive--2__title-container'>
					<p className='chapter-3__deep-dive--2__title'>{content.chapters.third.deep_dive_section_2.title}</p>
					<img className='chapter-3__deep-dive--2__bg-shape' src={`${mainScript.assetPath}images/svg/graphics/bg-shape--yellow-curve.svg`} alt="" />
				</div>
				<div className='chapter-3__deep-dive--2__text-container'>
					<DeepDiveParagraph 
						paragraph={content.chapters.third.deep_dive_section_2.paragraph_1}
						elClass='chapter-3__deep-dive--2'
						chapterNum='third'
						section='deep_dive_section_2'
						deepDiveImages={deepDiveImages}
					/>
					<p>{content.chapters.third.deep_dive_section_2.paragraph_2}</p>
				</div>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default DeepDive2;